import { LoaderIcon } from "config/IconConfig";
import { Image } from "antd";

const CustomLoader = () => (
  <div
    style={{
      width: "80%",
      textAlign: "center",
      top: 200,
      position: "absolute",
      zIndex: 1001,
    }}
  >
    <Image
      src={LoaderIcon}
      alt="Loader"
      preview={false}
      style={{ textAlign: "center" }}
    />
  </div>
);

export default CustomLoader;
